/* eslint-disable no-shadow */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { GoTriangleRight } from 'react-icons/go';
import { useLoadScript } from '@react-google-maps/api';
import Autocomplete from '@material-ui/lab/Autocomplete';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import Input from '../../components/Input';
import AccountsService from '../../services/accounts';
import Loader from '../../components/Loader';
import LoaderSubLine from './LoaderSubLine';
import api from '../../services/api';
import { ReactComponent as Bus } from '../../assets/Shared/Bus.svg';
import { ReactComponent as ClockIcon } from '../../assets/RoutesAndLines/clock.svg';
import Accordion from '../../components/Accordion';
import Button from '../../components/Button';
import Header from '../../components/Home/Header';
import NavBar from '../../components/Home/NavBar';
import Lupasearch from '../../assets/Shared/lupasearch.svg';
import { useToast } from '../../hooks/toast';
import { Container, Content, Blur } from '../../styles/components';
import Lupaorange from '../../assets/RoutesAndLines/Lupaorange.png';
import { useAuth } from '../../hooks/auth';
import {
  TitleSection,
  GridSection,
  Main,
  Aside,
  AsideCard,
  CollapseContainer,
  TimeContainer,
  Dialogo,
  Modal,
  Dialogoline,
  Modalline,
  DivEstacao,
  DivMenuEstações,
} from './styles';
import Footer from '../../components/Home/Footer';

declare type Libraries = (
  | 'drawing'
  | 'geometry'
  | 'localContext'
  | 'places'
  | 'visualization'
)[];

interface Favoritas {
  id: number;
  user: number;
  code_line: string;
  name_line: string;
  sgl_line: string;
  follow: boolean;
}

interface LineItem {
  code: string;
  sgl: string;
  itinerario: any;
  name: string;
  tabelahorario: any;
  follow: boolean;
}

interface LineEstItem {
  linha: string;
  nome: string;
  display: any;
  type: string;
  follow: boolean;
}

interface Line {
  cod: string;
  sgl: string;
  nom: string;
  display: string;
}

interface Itineraries {
  code: string;
  sgl: string;
  name: string;
  itinerario: any;
  tabelahorario: any;
}

const libraries: Libraries = ['places'];

const RoutesAndLines: React.FC = () => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
    language: 'pt-BR',
  });
  const { user } = useAuth();
  const servicesAccounts = { AccountsService: new AccountsService() };
  const formRef = useRef<FormHandles>(null);
  const { push } = useHistory();
  const [buscaLinha, setBuscaLinha] = useState<any>();
  const { addToast } = useToast();
  const [linhas, setLinhas] = useState<Itineraries[]>([]);
  const [rotas, setRotas] = useState<Line[]>([]);
  const [favoritas, setFavoritas] = useState<Favoritas[]>([]);
  const [line, setLine] = useState<LineItem | null>();
  const [lineEst, setLineEst] = useState<LineEstItem | null>();
  const [value, setValue] = React.useState(null);
  const [inputValue, setInputValue] = useState<any>();
  const [origin, setOrigin] = React.useState<string>('');
  const [destination, setDestination] = React.useState<string>('');
  const [loading, setLoading] = React.useState<boolean>(true);
  const [loadingSubLine, setLoadingSubLine] = React.useState<boolean>(false);
  const [subLinhas, setSubLinhas] = React.useState<any>([]);
  const [subLines, setSubLines] = React.useState<any>([]);

  useEffect(() => {
    async function getLinhas() {
      try {
        setLoading(true);
        const response = await api.get('/core/lines/');
        setLinhas(response.data.lines);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    }
    getLinhas();
  }, []);
const estacoes = [
  { linha: '1000', nome: 'ESTAÇÃO DIAMANTE', display: 'ESTAÇÃO DIAMANTE' },
  { linha: '1001', nome: 'LINHA DE BLOQUEIO ESTAÇÃO DIAMANTE', display: 'LINHA DE BLOQUEIO ESTAÇÃO DIAMANTE' },
  { linha: '1002', nome: 'LINHA BLOQUEIO ESTAÇÃO DIAMANTE ACESSO LOJAS', display: 'LINHA BLOQUEIO ESTAÇÃO DIAMANTE ACESSO LOJAS' },
  { linha: '2000', nome: 'ESTACAO VENDA NOVA', display: 'ESTACAO VENDA NOVA' },
  { linha: '2001', nome: 'LINHA DE BLOQUEIO ESTAÇÃO VENDA NOVA', display: 'LINHA DE BLOQUEIO ESTAÇÃO VENDA NOVA' },
  { linha: '3000', nome: 'ACESSO ESTAÇÃO SAO GABRIEL', display: 'ACESSO ESTAÇÃO SAO GABRIEL' },
  { linha: '3001', nome: 'LINHAS BLOQUEIO SÃO GABRIEL', display: 'LINHAS BLOQUEIO SÃO GABRIEL' },
  { linha: '3002', nome: 'LINHA BLOQUEIO MOVE SÃO GABRIEL (TARIFA A)', display: 'LINHA BLOQUEIO MOVE SÃO GABRIEL (TARIFA A)' },
  { linha: '4001', nome: 'LINHA DE BLOQUEIO ESTAÇÃO BARREIRO', display: 'LINHA DE BLOQUEIO ESTAÇÃO BARREIRO' },
  { linha: '4002', nome: 'ESTAÇAO BARREIRO', display: 'ESTAÇAO BARREIRO' },
  { linha: '4003', nome: 'ESTAÇÃO BARREIRO SAÍDA / ACESSO SHOPPING', display: 'ESTAÇÃO BARREIRO SAÍDA / ACESSO SHOPPING' },
  { linha: '4004', nome: 'LINHA DE BLOQUEIO ESTAÇÃO BARREIRO ACESSO LOJAS', display: 'LINHA DE BLOQUEIO ESTAÇÃO BARREIRO ACESSO LOJAS' },
  { linha: '6000', nome: 'ACESSO ESTAÇÃO PAMPULHA', display: 'ACESSO ESTAÇÃO PAMPULHA' },
  { linha: '6001', nome: 'LINHAS BLOQUEIO ESTAÇÃO PAMPULHA', display: 'LINHAS BLOQUEIO ESTAÇÃO PAMPULHA' },
  { linha: '7000', nome: 'LINHAS ACESSO ESTAÇÃO VILARINHO', display: 'LINHAS ACESSO ESTAÇÃO VILARINHO' },
  { linha: '7001', nome: 'LINHAS BLOQUEIO ESTAÇÃO VILARINHO', display: 'LINHAS BLOQUEIO ESTAÇÃO VILARINHO' },
  { linha: 'AC01', nome: 'ESTAÇÃO TRANSF. CANDELÁRIA', display: 'ESTAÇÃO TRANSF. CANDELÁRIA' },
  { linha: 'AC02', nome: 'ESTAÇÃO TRANSF. MINAS CAIXA', display: 'ESTAÇÃO TRANSF. MINAS CAIXA' },
  { linha: 'AC03', nome: 'ESTAÇÃO TRANSF. QUADRAS DO VILARINHO', display: 'ESTAÇÃO TRANSF. QUADRAS DO VILARINHO' },
  { linha: 'AC04', nome: 'ESTAÇÃO TRANSF. UPA VENDA NOVA', display: 'ESTAÇÃO TRANSF. UPA VENDA NOVA' },
  { linha: 'AC05', nome: 'ESTAÇÃO TRANSF. CRISTIANO GUIMARÃES', display: 'ESTAÇÃO TRANSF. CRISTIANO GUIMARÃES' },
  { linha: 'AC06', nome: 'ESTAÇÃO TRANSF. PLANALTO', display: 'ESTAÇÃO TRANSF. PLANALTO' },
  { linha: 'AC07', nome: 'ESTAÇÃO TRANSF. SÃO JOÃO BATISTA', display: 'ESTAÇÃO TRANSF. SÃO JOÃO BATISTA' },
  { linha: 'AC08', nome: 'ESTAÇÃO TRANSF. LAGOA DO NADO', display: 'ESTAÇÃO TRANSF. LAGOA DO NADO' },
  { linha: 'AC09', nome: 'ESTAÇÃO TRANSF. MONTESE', display: 'ESTAÇÃO TRANSF. MONTESE' },
  { linha: 'AC10', nome: 'ESTAÇÃO TRANSF. MONTE CASTELO', display: 'ESTAÇÃO TRANSF. MONTE CASTELO' },
  { linha: 'AC12', nome: 'ESTAÇÃO TRANSF. SANTA ROSA', display: 'ESTAÇÃO TRANSF. SANTA ROSA' },
  { linha: 'AC13', nome: 'ESTAÇÃO TRANSF. MINEIRÃO', display: 'ESTAÇÃO TRANSF. MINEIRÃO' },
  { linha: 'AC14', nome: 'ESTAÇÃO TRANSF. UFMG', display: 'ESTAÇÃO TRANSF. UFMG' },
  { linha: 'AC15', nome: 'ESTAÇÃO TRANSF. LIBERDADE', display: 'ESTAÇÃO TRANSF. LIBERDADE' },
  { linha: 'AC16', nome: 'ESTAÇÃO TRANSF. COLÉGIO MILITAR', display: 'ESTAÇÃO TRANSF. COLÉGIO MILITAR' },
  { linha: 'AC17', nome: 'ESTAÇÃO TRANSF. SÃO FRANCISCO', display: 'ESTAÇÃO TRANSF. SÃO FRANCISCO' },
  { linha: 'AC18', nome: 'ESTAÇÃO TRANSF. CACHOEIRINHA', display: 'ESTAÇÃO TRANSF. CACHOEIRINHA' },
  { linha: 'AC19', nome: 'ESTAÇÃO TRANSF. AMÉRICO VESPÚCIO', display: 'ESTAÇÃO TRANSF. AMÉRICO VESPÚCIO' },
  { linha: 'AC20', nome: 'ESTAÇÃO TRANSF. APARECIDA', display: 'ESTAÇÃO TRANSF. APARECIDA' },
  { linha: 'AC21', nome: 'ESTAÇÃO TRANSF. OPERÁRIOS', display: 'ESTAÇÃO TRANSF. OPERÁRIOS' },
  { linha: 'AC22', nome: 'ESTAÇÃO TRANSF. HOSPITAL BELO HORIZONTE', display: 'ESTAÇÃO TRANSF. HOSPITAL BELO HORIZONTE' },
  { linha: 'AC23', nome: 'ESTAÇÃO TRANSF. IAPI', display: 'ESTAÇÃO TRANSF. IAPI' },
  { linha: 'AC24', nome: 'ESTAÇÃO TRANSF. HOSPITAL ODILON BEHRENS', display: 'ESTAÇÃO TRANSF. HOSPITAL ODILON BEHRENS' },
  { linha: 'CM02', nome: 'ESTAÇÃO DE TRANSF. MINAS SHOPPING', display: 'ESTAÇÃO DE TRANSF. MINAS SHOPPING' },
  { linha: 'CM03', nome: 'ESTAÇÃO DE TRANSF. OURO MINAS', display: 'ESTAÇÃO DE TRANSF. OURO MINAS' },
  { linha: 'CM04', nome: 'ESTAÇÃO DE TRANSF. UNIÃO', display: 'ESTAÇÃO DE TRANSF. UNIÃO' },
  { linha: 'CM05', nome: 'ESTAÇÃO DE TRANSF. IPIRANGA', display: 'ESTAÇÃO DE TRANSF. IPIRANGA' },
  { linha: 'CM06', nome: 'ESTAÇÃO DE TRANSF. CIDADE NOVA', display: 'ESTAÇÃO DE TRANSF. CIDADE NOVA' },
  { linha: 'CM07', nome: 'ESTAÇÃO DE TRANSF. FEIRA DOS PRODUTORES', display: 'ESTAÇÃO DE TRANSF. FEIRA DOS PRODUTORES' },
  { linha: 'CM08', nome: 'ESTAÇÃO DE TRANSF. SÃO JUDAS TADEU', display: 'ESTAÇÃO DE TRANSF. SÃO JUDAS TADEU' },
  { linha: 'CM09', nome: 'ESTAÇÃO DE TRANSF. SAGRADA FAMÍLIA', display: 'ESTAÇÃO DE TRANSF. SAGRADA FAMÍLIA' },
  { linha: 'PR01', nome: 'ESTAÇÃO DE TRANSF. TAMOIOS', display: 'ESTAÇÃO DE TRANSF. TAMOIOS' },
  { linha: 'PR02', nome: 'ESTAÇÃO DE TRANSF. CARIJÓS', display: 'ESTAÇÃO DE TRANSF. CARIJÓS' },
  { linha: 'SD01', nome: 'ESTAÇÃO DE TRANSF. SÃO PAULO', display: 'ESTAÇÃO DE TRANSF. SÃO PAULO' },
  { linha: 'SD02', nome: 'ESTAÇÃO DE TRANSF. RIO DE JANEIRO', display: 'ESTAÇÃO DE TRANSF. RIO DE JANEIRO' },
  { linha: 'AC25', nome: 'ESTAÇÃO TRANSF. SENAI', display: 'ESTAÇÃO TRANSF. SENAI' },
  { linha: 'AC26', nome: 'ESTAÇÃO TRANSF. LAGOINHA', display: 'ESTAÇÃO TRANSF. LAGOINHA' },
  { linha: 'CM10', nome: 'ESTAÇÃO DE TRANSF. SILVIANO BRANDÃO', display: 'ESTAÇÃO DE TRANSF. SILVIANO BRANDÃO' },
];

  useEffect(() => {
  async function getRotas() {
    try {
      setLoading(true);
      const response = await api.get('/core/lines/');

      // Processar linhas do response
      const responseRotas = response.data.lines.map((rota: any) => {
        const matchingEstacao = estacoes.find(
          (estacao) => estacao.linha === String(rota.sgl)
        );
        return {
          ...rota,
          estacao: matchingEstacao || null, // Inclui estacao se houver correspondência, senão null
          type: 'response', // Identifica origem como response
        };
      });

      // Processar entradas de estacoes
      const estacoesRotas = estacoes.map((estacao) => ({
        linha: estacao.linha,
        nome: estacao.nome,
        display: estacao.display,
        type: 'estacao', // Identifica origem como estacao
        estacao, // Inclui todos os dados de estacao
      }));

      // Combinar os dois arrays
      const combinedRotas = [...responseRotas, ...estacoesRotas];
      setRotas(combinedRotas);
    } catch (err) {
      const modallines = document.getElementById('lines');
      if (modallines) modallines.style.display = 'none';
      console.error('Erro ao buscar rotas:', err);
      addToast({
        type: 'error',
        title: 'Erro ao carregar rotas',
        description: 'Não foi possível carregar as rotas. Tente novamente.',
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }
  getRotas();
}, [addToast]);

  const handleSubmit = useCallback(() => {
    const getLines = async () => {
      setLine(null);
      try {
        setLoading(true);

        console.log(value);
        if (value.linha) {
          setLineEst(value);
          setLine(null);
        } else if (value.sgl) {
          const response = await api.get(`/core/v2/line-info/${value.cod}/`);
          setLineEst(null);
          setLine(response.data);
        } else {
          const responses = await api.get(`/core/v2/line-info/${value}/`);
          setLine(responses.data);
        }
        setLoading(false);
        const modallines = document.getElementById('lines');
        modallines.style.display = 'none';
      } catch (err) {
        setLoading(false);
        const modal = document.getElementById('errorline');
        modal.style.display = 'block';
        const modallines = document.getElementById('lines');
        modallines.style.display = 'none';
      }
    };
    getLines();
  }, [value, estacoes]);

  const onChangeAutocomplete = useCallback(
    (event: any, newValue: Line) => {
      console.log(newValue);
      setValue(newValue);
    },
    [setValue],
  );

  const handleSubmitLinhas = useCallback(data => {
    const getLines = async () => {
      setLine(null);
      try {
        setLoading(true);
        const response = await api.get('/core/lines/');
        const filteredLines = response.data.lines.filter(
          (f: any) => f.sgl === data.search,
        );
        const responseLinha = await api.get(
          `/core/line-info/${filteredLines[0].sgl}/`,
        );
        setRotas(responseLinha.data.lines);
        setLine(responseLinha.data);
        setLoading(false);
        const modallines = document.getElementById('lines');
        modallines.style.display = 'none';
        const modal = document.getElementById('errorline');
        modal.style.display = 'none';
      } catch (err) {
        setLoading(false);
        const modal = document.getElementById('errorline');
        modal.style.display = 'block';
        const modallines = document.getElementById('lines');
        modallines.style.display = 'none';
      }
    };
    getLines();
  }, []);

  useEffect(() => {
    setInputValue(inputValue);
  }, [inputValue]);

  const handleOrigin = useCallback(address => {
    setOrigin(address);
  }, []);

  const handleDestination = useCallback(address => {
    setDestination(address);
  }, []);

  useEffect(() => {
    async function getFavoritas() {
      try {
        if (user) {
          setLoading(true);
          const response = await servicesAccounts.AccountsService.getLineFavorite();
          setFavoritas(response.data.results);
          // setLoading(false);
        }
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    }
    getFavoritas();
  }, [user]);

  const handleCreateFavorite = useCallback(
    async data => {
      try {
        console.log(data);
        await servicesAccounts.AccountsService.createLineFavorite({
          ...data,
        });
        const response = await api.get('/core/lines/');
        const filteredLines = response.data.lines.filter(
          (f: any) => f.sgl === data.search,
        );
        const responseLinha = await api.get(
          `/core/line-info/${filteredLines[0].cod}/`,
        );
        console.log({ responseLinha });
        const responsefavorites = await servicesAccounts.AccountsService.getLineFavorite();
        setFavoritas(responsefavorites.data.results);
        setLine(null);
        setLine(response.data);
      } catch (err: any) {
        const { ...error } = err;
        console.error(error);
      } finally {
        window.location.reload();
      }
    },
    [servicesAccounts.AccountsService],
  );

  const handleRemoveFavorite = useCallback(
    async data => {
      try {
        await servicesAccounts.AccountsService.deleteLineFavorite(
          data.favorite,
        );
        const response = await api.get('/core/lines/');
        const filteredLines = response.data.lines.filter(
          (f: any) => f.sgl === data.search,
        );
        const responseLinha = await api.get(
          `/core/line-info/${filteredLines[0].cod}/`,
        );
        console.log({ responseLinha });
        const responsefavorites = await servicesAccounts.AccountsService.getLineFavorite();
        const responselinhas = await api.get('/core/lines-itineraries/');
        setFavoritas(responsefavorites.data.results);
        setLinhas([]);
        setLinhas(responselinhas.data.lines_with_itinerary);
        setLine(null);
        setLine(response.data);
      } catch (err: any) {
        const { ...error } = err;
        console.error(error);
      }
    },
    [servicesAccounts.AccountsService],
  );

  const handleFavorite = useCallback(
    async data => {
      const filteredFavorite = favoritas.filter((favorita: any) => {
        return favorita.sgl_line === data.sgl_line;
      });
      console.log(data);
      try {
        if (data.follow) {
          handleRemoveFavorite({
            favorite: filteredFavorite[0].id,
            slg: data.sgl_line,
          });
        } else {
          handleCreateFavorite(data);
        }
      } catch (err: any) {
        const { ...error } = err;
        console.error(error);
      }
    },
    [favoritas, handleCreateFavorite, handleRemoveFavorite],
  );
  const handleFavoriteEstacao = useCallback(
    async (data: { sgl_line: string; code_line: string; name_line: string; follow: boolean }) => {
      const filteredFavorite = favoritas.find((favorita: any) => favorita.sgl_line === data.sgl_line);
      console.log('Dados do favorito:', data);
      try {
        if (data.follow && filteredFavorite) {
          await handleRemoveFavorite({
            favorite: filteredFavorite.id,
            sgl: data.sgl_line,
          });
        } else {
          await handleCreateFavorite({
            sgl_line: data.sgl_line,
            code_line: data.code_line,
            name_line: data.name_line,
            follow: true,
          });
        }
      } catch (err: any) {
        console.error('Erro ao manipular favorito:', err);
        addToast({
          type: 'error',
          title: 'Erro ao manipular favorito',
          description: 'Não foi possível adicionar/remover o favorito. Tente novamente.',
        });
      }
    },
    [favoritas, handleCreateFavorite, handleRemoveFavorite, addToast]
  );

  const handleSearchMap = useCallback(() => {
    if (destination && origin) {
      const encodedQueryParams = encodeURI(
        `?origin=${origin}&destination=${destination}`,
      );
      window.location.href = `/trajetos/${encodedQueryParams}`;
    } else {
      addToast({
        type: 'info',
        title: 'Selecione primeiro a origem e destino',
        description: 'Não foi possível redirecionar para o mapa',
      });
    }
  }, [destination, origin, addToast]);

  const handleSublines = useCallback(async (cod: any) => {
    setLoadingSubLine(true);
    const response = await api.get(`/core/sub-lines/${cod}/`);
    try {
      if (response?.data?.sub_lines?.length !== 0) {
        const responseSubLinhas = response.data.sub_lines.map(async (sub: any) => {
          const responsibles = await api.get(`/core/v2/line-info/${sub.cod}/`);
          return responsibles.data;
        });
        const promisesResponse = await Promise.all(responseSubLinhas);

        const responseSubLines = await api.get(`/core/sub-lines/${cod}/`);
        const sublinhas = responseSubLines.data.sub_lines.map((sub: any) => sub);
        const changedResponse = promisesResponse.map((item: any) => {
          const filteredSubline = response.data.sub_lines.filter(
            (subline: any) => subline.cod === Number(item.code),
          )[0];
          return { ...item, sublineName: filteredSubline.nom };
        });
        setSubLinhas(sublinhas);
        setSubLines(changedResponse);
        setLoadingSubLine(false);
        return {};
      }
    } catch (err: any) {
        const { ...error } = err;
        console.error(error);
      }
  }, []);

  return (
    <>
      <Container>
        <Content>
          <Header />
        </Content>
      </Container>
      <Container backgroundImage className="companies-container">
        <Blur>
          <Content className="content">
            <NavBar />
            <TitleSection>
              <h1>Rotas e Linhas</h1>
              <span>Confira o itinerário e rotas</span>
            </TitleSection>
          </Content>
        </Blur>
      </Container>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Container backgroundColor="background-gray">
            <Content>
              <GridSection>
                <Main>
                  <h2>Digite o número ou nome da linha desejada</h2>

                  <div className="inputcontainer">
                    <Autocomplete
                      freeSolo
                      id="free-solo-2-demo"
                      options={rotas}
                      getOptionLabel={rota => rota.display}
                      value={value}
                      autoHighlight
                      onChange={onChangeAutocomplete}
                      inputValue={inputValue}
                      onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                      }}
                      onFocus={() => setValue(null)}
                      onSelect={value && handleSubmit}
                      renderInput={params => (
                        <div
                          className="inputWrapper"
                          ref={params.InputProps.ref}
                        >
                          <input
                            type="text"
                            placeholder="Pesquise linhas"
                            {...params.inputProps}
                            className="input"
                            onKeyPress={event =>
                              event.key === 'Enter' && handleSubmit()
                            }
                          />

                          {/* <Button
                            type="submit"
                            color="orange"
                            padding="3"
                            className="button"
                          >
                            <span className="btn-buscar">BUSCAR</span>
                            <img
                              src={Lupasearch}
                              alt="search"
                              className="btn-search"
                            />
                          </Button> */}
                        </div>
                      )}
                    />
                    <Form ref={formRef} onSubmit={handleSubmit}>
                      <Input
                        name="search"
                        className="buscalinha"
                        placeholder="Pesquise Linhas ou paradas"
                        defaultValue={inputValue}
                        onChange={e => setBuscaLinha(e.target.value)}
                      >
                        {value !== null ? (
                          <Button
                            type="submit"
                            color="orange"
                            padding="3"
                            className="button"
                          >
                            <span className="btn-buscar">BUSCAR</span>
                            <img
                              src={Lupasearch}
                              alt="search"
                              className="btn-search"
                            />
                          </Button>
                        ) : (
                          <Button
                            type="submit"
                            color="gray-line"
                            padding="3"
                            className="button"
                            disabled
                          >
                            <span className="btn-buscar">BUSCAR</span>
                            <img
                              src={Lupasearch}
                              alt="search"
                              className="btn-search"
                            />
                          </Button>
                        )}
                      </Input>
                    </Form>
                  </div>
                  <DivMenuEstações>
                    {lineEst ? (
                      <div>
                          <DivEstacao>
                            <div className='title-container'>
                              <LocationCityIcon className='icon-class'/>
                              <div>
                                <h2>
                                  {lineEst.nome}
                                </h2>
                              </div>
                            </div>
                            <div className='star-container'>
                              {favoritas && favoritas.some((favorita) => favorita.sgl_line === lineEst.linha) ? (
                                <StarIcon
                                  className="icon-star"
                                  onClick={() =>
                                    handleFavoriteEstacao({
                                      sgl_line: lineEst.linha,
                                      code_line: lineEst.linha,
                                      name_line: lineEst.nome,
                                      follow: true,
                                    })
                                  }
                                />
                              ) : (
                                <StarBorderIcon
                                  className="icon-star"
                                  onClick={() =>
                                    handleFavoriteEstacao({
                                      sgl_line: lineEst.linha,
                                      code_line: lineEst.linha,
                                      name_line: lineEst.nome,
                                      follow: false,
                                    })
                                  }
                                />
                              )}
                            </div>
                          </DivEstacao>
                      </div>
                    ) : (<></>)}
                </DivMenuEstações>

                  {line && (
                    <Accordion
                      key={line.code}
                      cod={line.code}
                      CollapseIcon={GoTriangleRight}
                      title={line.sgl}
                      subTitle={line.name}
                      fav={line.follow}
                      handleFavorite={handleFavorite}
                      name={user && line.name}
                      Icon={Bus}
                      handleSublines={handleSublines}
                      hasSublines
                    >
                      {loadingSubLine ? (
                        <LoaderSubLine />
                      ) : (
                        <>
                          {subLinhas[1] &&
                            subLines.map((sub: any) => (
                              <>
                                {Object.keys(sub.tabelahorario).length > 0 && (
                                  <Accordion
                                    key={sub.code}
                                    CollapseIcon={GoTriangleRight}
                                    title={line.sgl}
                                    subTitle={sub.sublineName}
                                  >
                                    <CollapseContainer>
                                      {Object.keys(sub.tabelahorario).map(
                                        (rota: any) => {
                                          return (
                                            <>
                                              <h3>{rota}</h3>
                                              {Object.keys(
                                                sub.tabelahorario[rota],
                                              ).map((dia: any) => {
                                                return (
                                                  <>
                                                    {!dia.includes('Covid') && (
                                                      <>
                                                        <TimeContainer
                                                          key={rota}
                                                        >
                                                          <div className="sub-ball-container">
                                                            <div>
                                                              <ClockIcon />
                                                            </div>
                                                          </div>
                                                          <div className="text-container">
                                                            <h1>{dia}</h1>
                                                            <div className="flex">
                                                              {sub.tabelahorario[
                                                                rota
                                                              ][dia].map(
                                                                (item: any) => {
                                                                  return (
                                                                    <div
                                                                      className="horario"
                                                                      key={item}
                                                                    >
                                                                      {item}
                                                                    </div>
                                                                  );
                                                                },
                                                              )}
                                                            </div>
                                                          </div>
                                                        </TimeContainer>
                                                      </>
                                                    )}
                                                  </>
                                                );
                                              })}
                                            </>
                                          );
                                        },
                                      )}
                                      <h1>Itinerário</h1>
                                      {Object.keys(sub.itinerario).map(
                                        (ponto: any) => {
                                          return (
                                            <>
                                              <div className="text-container">
                                                <h3
                                                  className="localizacao-pontos"
                                                  key={ponto}
                                                >
                                                  {ponto}
                                                </h3>
                                              </div>
                                              {Object.keys(
                                                sub.itinerario[ponto],
                                              ).map((localizacao: any) => {
                                                return (
                                                  <div key={localizacao}>
                                                    {
                                                      sub.itinerario[ponto][
                                                        localizacao
                                                      ]
                                                    }
                                                  </div>
                                                );
                                              })}
                                            </>
                                          );
                                        },
                                      )}
                                    </CollapseContainer>
                                  </Accordion>
                                )}
                              </>
                            ))}
                          {!subLinhas[1] && (
                            <CollapseContainer>
                              {Object.keys(line.tabelahorario).map(
                                (rota: any) => {
                                  return (
                                    <>
                                      <h3>{rota}</h3>
                                      {Object.keys(
                                        line.tabelahorario[rota],
                                      ).map((dia: any) => {
                                        return (
                                          <>
                                            {!dia.includes('Covid') && (
                                              <>
                                                <TimeContainer key={rota}>
                                                  <div className="sub-ball-container">
                                                    <div>
                                                      <ClockIcon />
                                                    </div>
                                                  </div>
                                                  <div className="text-container">
                                                    <h1>{dia}</h1>
                                                    <div className="flex">
                                                      {line.tabelahorario[rota][
                                                        dia
                                                      ].map((item: any) => {
                                                        return (
                                                          <div
                                                            className="horario"
                                                            key={item}
                                                          >
                                                            {item}
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </div>
                                                </TimeContainer>
                                              </>
                                            )}
                                          </>
                                        );
                                      })}
                                    </>
                                  );
                                },
                              )}
                              <h1>Itinerário</h1>
                              {Object.keys(line.itinerario).map(
                                (ponto: any) => {
                                  return (
                                    <>
                                      <div className="text-container">
                                        <h3
                                          className="localizacao-pontos"
                                          key={ponto}
                                        >
                                          {ponto}
                                        </h3>
                                      </div>
                                      {Object.keys(line.itinerario[ponto]).map(
                                        (localizacao: any) => {
                                          return (
                                            <div key={localizacao}>
                                              {
                                                line.itinerario[ponto][
                                                  localizacao
                                                ]
                                              }
                                            </div>
                                          );
                                        },
                                      )}
                                    </>
                                  );
                                },
                              )}
                            </CollapseContainer>
                          )}
                        </>
                      )}
                    </Accordion>
                  )}
                  <Modalline id="lines">
                    <Dialogoline>
                      {linhas &&
                        linhas.map((linha: any) => {
                          const matchingEstacao = estacoes.find((estacao: any) => estacao.linha === linha.sgl);
                          return matchingEstacao ? (
                            <DivEstacao key={linha.code}>
                          <div className="title-container">
                            <LocationCityIcon className="icon-class" />
                            <div className='text-container-estacao'>
                              <h2 style={{ color: "var(--orange)" }}>
                                {matchingEstacao.nome}
                              </h2>
                            </div>
                          </div>
                          
                          <div className="star-container">
                            <StarIcon
                                className='icon-star_full'
                                style={{ color: "var(--orange)"}}
                                onClick={() =>
                                  handleFavoriteEstacao({
                                    sgl_line: matchingEstacao.linha,
                                    code_line: matchingEstacao.linha,
                                    name_line: matchingEstacao.nome,
                                    follow: true,
                                  })
                                }
                              />
                          </div>
                        </DivEstacao>
                        ) : (
                          <Accordion
                            key={linha.cod}
                            cod={linha.cod}
                            CollapseIcon={GoTriangleRight}
                            title={linha.sgl}
                            handleFavorite={handleFavorite}
                            name={user && linha.nom}
                            subTitle={linha.nom}
                            Icon={Bus}
                            handleSublines={handleSublines}
                            hasSublines
                          >
                            {loadingSubLine ? (
                              <LoaderSubLine />
                            ) : (
                              <>
                                {subLinhas[1] &&
                                  subLines.map((sub: any) => (
                                    <>
                                      {Object.keys(sub.tabelahorario).length >
                                        0 && (
                                        <Accordion
                                          key={sub.code}
                                          CollapseIcon={GoTriangleRight}
                                          title={linha.sgl}
                                          subTitle={sub.sublineName}
                                        >
                                          <CollapseContainer>
                                            {Object.keys(sub.tabelahorario).map(
                                              (rota: any) => {
                                                return (
                                                  <>
                                                    <h3>{rota}</h3>
                                                    {Object.keys(
                                                      sub.tabelahorario[rota],
                                                    ).map((dia: any) => {
                                                      return (
                                                        <>
                                                          {!dia.includes(
                                                            'Covid',
                                                          ) && (
                                                            <>
                                                              <TimeContainer
                                                                key={rota}
                                                              >
                                                                <div className="sub-ball-container">
                                                                  <div>
                                                                    <ClockIcon />
                                                                  </div>
                                                                </div>
                                                                <div className="text-container">
                                                                  <h1>{dia}</h1>
                                                                  <div className="flex">
                                                                    {sub.tabelahorario[
                                                                      rota
                                                                    ][dia].map(
                                                                      (
                                                                        item: any,
                                                                      ) => {
                                                                        return (
                                                                          <div
                                                                            className="horario"
                                                                            key={
                                                                              item
                                                                            }
                                                                          >
                                                                            {
                                                                              item
                                                                            }
                                                                          </div>
                                                                        );
                                                                      },
                                                                    )}
                                                                  </div>
                                                                </div>
                                                              </TimeContainer>
                                                            </>
                                                          )}
                                                        </>
                                                      );
                                                    })}
                                                  </>
                                                );
                                              },
                                            )}
                                            <h1>Itinerário</h1>
                                            {Object.keys(sub.itinerario).map(
                                              (ponto: any) => {
                                                return (
                                                  <>
                                                    <div className="text-container">
                                                      <h3
                                                        className="localizacao-pontos"
                                                        key={ponto}
                                                      >
                                                        {ponto}
                                                      </h3>
                                                    </div>
                                                    {Object.keys(
                                                      sub.itinerario[ponto],
                                                    ).map(
                                                      (localizacao: any) => {
                                                        return (
                                                          <div
                                                            key={localizacao}
                                                          >
                                                            {
                                                              sub.itinerario[
                                                                ponto
                                                              ][localizacao]
                                                            }
                                                          </div>
                                                        );
                                                      },
                                                    )}
                                                  </>
                                                );
                                              },
                                            )}
                                          </CollapseContainer>
                                        </Accordion>
                                      )}
                                    </>
                                  ))}
                                {/* {!subLinhas[1] && (
                                  <CollapseContainer>
                                    {Object.keys(linha.tabelahorario).map(
                                      (rota: any) => {
                                        return (
                                          <>
                                            <h3>{rota}</h3>
                                            {Object.keys(
                                              linha.tabelahorario[rota],
                                            ).map((dia: any) => {
                                              return (
                                                <>
                                                  {!dia.includes('Covid') && (
                                                    <>
                                                      <TimeContainer key={rota}>
                                                        <div className="sub-ball-container">
                                                          <div>
                                                            <ClockIcon />
                                                          </div>
                                                        </div>
                                                        <div className="text-container">
                                                          <h1>{dia}</h1>
                                                          <div className="flex">
                                                            {linha.tabelahorario[
                                                              rota
                                                            ][dia].map(
                                                              (item: any) => {
                                                                return (
                                                                  <div
                                                                    className="horario"
                                                                    key={item}
                                                                  >
                                                                    {item}
                                                                  </div>
                                                                );
                                                              },
                                                            )}
                                                          </div>
                                                        </div>
                                                      </TimeContainer>
                                                    </>
                                                  )}
                                                </>
                                              );
                                            })}
                                          </>
                                        );
                                      },
                                    )}
                                    <h1>Itinerário</h1>
                                    {Object.keys(linha.itinerario).map(
                                      (ponto: any) => {
                                        return (
                                          <>
                                            <div className="text-container">
                                              <h3
                                                className="localizacao-pontos"
                                                key={ponto}
                                              >
                                                {ponto}
                                              </h3>
                                            </div>
                                            {Object.keys(
                                              linha.itinerario[ponto],
                                            ).map((localizacao: any) => {
                                              return (
                                                <div key={localizacao}>
                                                  {
                                                    linha.itinerario[ponto][
                                                      localizacao
                                                    ]
                                                  }
                                                </div>
                                              );
                                            })}
                                          </>
                                        );
                                      },
                                    )}
                                  </CollapseContainer>
                                )} */}
                              </>
                            )}
                          </Accordion>
                        )})}
                    </Dialogoline>
                  </Modalline>
                  <Modal id="errorline">
                    <Dialogo>
                      <div className="container">
                        <div className="text" id="text">
                          <img src={Lupaorange} alt="lupa" />
                          <h1>Nenhuma linha encontrada!</h1>
                          <p>Revise os dados digitados e pesquise novamente.</p>
                        </div>
                      </div>
                    </Dialogo>
                  </Modal>
                </Main>

                <Aside>
                  {isLoaded && (
                    <AsideCard>
                      <div className="header">Faça sua Rota</div>
                      <div className="main">
                        <Form ref={formRef} onSubmit={handleSubmit}>
                          <p className="highlight-label">
                            Seu Local de partida
                          </p>
                          <p>Digite seu lugar de origem</p>

                          <Input
                            onChange={e => handleOrigin(e.target.value)}
                            name="OrigemInput"
                            placeholder="Origem"
                          />

                          <p>Digite para onde você vai</p>
                          <Input
                            onChange={e => handleDestination(e.target.value)}
                            name="DestinoInput"
                            placeholder="Destino"
                          />

                          <Button
                            style={{ marginBottom: '12px' }}
                            type="button"
                            color="orange"
                            padding="5"
                            onClick={() => handleSearchMap()}
                            rounded
                          >
                            Buscar
                          </Button>
                        </Form>
                      </div>
                      <div className="footer">
                        <Button
                          onClick={() => push('trajetos/')}
                          type="submit"
                          color="white"
                          padding="4"
                          rounded
                        >
                          Ver Mapa
                        </Button>
                      </div>
                    </AsideCard>
                  )}
                </Aside>
              </GridSection>
            </Content>
          </Container>
          <Container>
            <Footer />
          </Container>
        </>
      )}
    </>
  );
};

export default RoutesAndLines;
